import extend from 'lodash/extend';
import find from 'lodash/find';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ISelectItem } from '@cakeiteasy/web-ui';
import { COUNTRIES, CustomComponent, POST_NUMBER_LENGTHS } from '@cakeiteasy/web-utils';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { CitiesApiService } from '../../../api-services/services/cities-api.service';
import { IDeliveryAddress } from '../../../users/models/i-delivery-address';
import { UserManager } from '../../../users/services/user.manager';
import { debounceTime, map, distinctUntilChanged, filter } from 'rxjs/operators';

@Component({
  standalone: false,
  templateUrl: './delivery-address-modal.component.html'
})
export class DeliveryAddressModalComponent extends CustomComponent implements OnInit {
  public da = {
    note: '',
    phone: '',
    address: '',
    country: '',
    cityName: '',
    recipient: '',
    postNumber: ''
  } as IDeliveryAddress;

  public deliveryAddress: any;
  public cityNotFound: boolean;
  public countryCodeItem: any;
  public onPostNumberUpdated$ = new Subject<string>();
  public saving: Promise<any>;
  public busy: Promise<any>;

  public countryCodeItems: ISelectItem[];

  constructor(public modal: NgbActiveModal,
              private _translate: TranslateService,
              private _users: UserManager,
              private _city: CitiesApiService) {
    super();
    this.countryCodeItems = [{
      label: this._translate.instant('common.countries.norway'),
      value: COUNTRIES.NORWAY,
      ref: COUNTRIES.NORWAY,
      isDefaultValue: false
    }, {
      label: this._translate.instant('common.countries.sweden'),
      value: COUNTRIES.SWEDEN,
      ref: COUNTRIES.SWEDEN,
      isDefaultValue: false
    }];
  }

  ngOnInit() {
    extend(this.da, this.deliveryAddress);
    this.countryCodeItem = find(this.countryCodeItems, (item) => item.value === this.da.country);
    this._subscribe();
  }

  public addDeliveryAddress() {
    this.saving = this._users.saveDeliveryAddress(this.da as IDeliveryAddress)
      .then((da) => this.modal.close(da));
  }

  public onCountryChange(selectedItem) {
    this.da.country = selectedItem.value;
    this.da.postNumber = null;
    this.da.cityName = null;
  }

  private _subscribe() {
    this.addSubscriber(this.onPostNumberUpdated$
      .pipe(map((postNumber) => {
        if (!postNumber || postNumber.length < POST_NUMBER_LENGTHS[this.da.country]) {
          this.da.cityName = null;
        }
        return postNumber;
      }))
      .pipe(debounceTime(350))
      .pipe(distinctUntilChanged())
      .pipe(filter((postNumber) => postNumber.length === POST_NUMBER_LENGTHS[this.da.country]))
      .subscribe((postNumber) => {
        this.busy = this._city.searchLocationByPostNumber(this.da.country, postNumber)
          .then((location) => {
            if (location) {
              this.da.cityName = location.placeName || location.cityName;
              this.cityNotFound = false;
            } else {
              this.cityNotFound = true;
            }
          });
      }));
  }
}
